// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__1u0OL","logoAccentDots":"Logo_logoAccentDots__1qtQF","logoSecondaryDots":"Logo_logoSecondaryDots__1LoWS","logoText":"Logo_logoText__Q9JUO"};